<div class="programers_content">
    <div class="sub_content">
        <h1 class="title">
            Programmes<br>
            <img src="../../../assets/img/new-kidzee/bottom_img.png" class="bottom_img_content" alt="">
        </h1>
        <div class="img_txt_list boysImg_deskView">

            <div class="program_img_list_content">
                <div class="row">
                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="../../../assets/img/new-kidzee/pg1.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">PlayGroup</div>
                                <p>Children in this age group as identified as Toddlers. Children are born curious. They
                                    begin to explore the environment...</p>
                                <p class="read_more" routerLink="/playgroup">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="../../../assets/img/new-kidzee/pg2.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Nursery</div>
                                <p>Children in this age group as identified as Toddlers. Children are born curious. They
                                    begin to explore the environment...</p>
                                <p class="read_more" routerLink="nursery">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="../../../assets/img/new-kidzee/pg3.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Junior K.G / Lower K.G</div>
                                <p>This is level 2 and 3 of preschool -Foundational Stage 1 - Mandatory as </p>
                                <p class="read_more" routerLink="kindergarten">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                                <div class="bottom_btn_list mt-2">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="../../../assets/img/new-kidzee/pg4.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Teacher Training Programme</div>
                                <p>Zee Learn Preschool Teacher Training Programme is a Zee Learn Ltd initiative. </p>
                                <p class="read_more" routerLink="teacher-training-programme">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="mobile_res">
            <div class="container my-4">

                <div id="carouselExampleDark" class="carousel carousel-dark slide">
                    <!-- <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active"
                            aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3"
                            aria-label="Slide 4"></button>
                    </div> -->
                    <div class="carousel-inner">
                        <div class="carousel-item active" data-bs-interval="10000">
                            <div class="card_content">
                                <div class="img_content">
                                    <img src="../../../assets/img/new-kidzee/pg1.png" width="100%" alt="">
                                </div>
                                <div class="bg_banner_content">
                                    <div class="d-flex justify-content-center icon_list_content">
                                        <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                            alt="">
                                    </div>
                                    <div class="card_title">PlayGroup</div>
                                    <p>Children in this age group as identified as Toddlers. Children are born curious.
                                        They begin to explore the environment...</p>
                                    <p class="read_more" routerLink="/playgroup">Read More</p>
                                    <div class="bottom_btn_list">
                                        <div class="bottom_btn">
                                            <div class="admission_text">Admission Age Group</div>
                                            <div class="years_text">1.5 - 2.5 Years</div>
                                        </div>
                                        <div class="bottom_btn">
                                            <div class="admission_text">Duration</div>
                                            <div class="years_text">3 Hours/Day</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="2000">
                            <div class="card_content">
                                <div class="img_content">
                                    <img src="../../../assets/img/new-kidzee/pg2.png" width="100%" alt="">
                                </div>
                                <div class="bg_banner_content">
                                    <div class="d-flex justify-content-center icon_list_content">
                                        <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                            alt="">
                                    </div>
                                    <div class="card_title">Nursery</div>
                                    <p>Children in this age group as identified as Toddlers. Children are born curious.
                                        They begin to explore the environment...</p>
                                    <p class="read_more" routerLink="nursery">Read More</p>
                                    <div class="bottom_btn_list">
                                        <div class="bottom_btn">
                                            <div class="admission_text">Admission Age Group</div>
                                            <div class="years_text">1.5 - 2.5 Years</div>
                                        </div>
                                        <div class="bottom_btn">
                                            <div class="admission_text">Duration</div>
                                            <div class="years_text">3 Hours/Day</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="3000">
                            <div class="card_content">
                                <div class="img_content">
                                    <img src="../../../assets/img/new-kidzee/pg3.png" width="100%" alt="">
                                </div>
                                <div class="bg_banner_content">
                                    <div class="d-flex justify-content-center icon_list_content">
                                        <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                            alt="">
                                    </div>
                                    <div class="card_title">Junior K.G / Lower K.G</div>
                                    <p>This is level 2 and 3 of preschool -Foundational Stage 1 - Mandatory as </p>
                                    <p class="read_more" routerLink="kindergarten">Read More</p>
                                    <div class="bottom_btn_list">
                                        <div class="bottom_btn">
                                            <div class="admission_text">Admission Age Group</div>
                                            <div class="years_text">1.5 - 2.5 Years</div>
                                        </div>
                                        <div class="bottom_btn">
                                            <div class="admission_text">Duration</div>
                                            <div class="years_text">3 Hours/Day</div>
                                        </div>
                                    </div>
                                    <div class="bottom_btn_list mt-2">
                                        <div class="bottom_btn">
                                            <div class="admission_text">Admission Age Group</div>
                                            <div class="years_text">1.5 - 2.5 Years</div>
                                        </div>
                                        <div class="bottom_btn">
                                            <div class="admission_text">Duration</div>
                                            <div class="years_text">3 Hours/Day</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div class="card_content">
                                <div class="img_content">
                                    <img src="../../../assets/img/new-kidzee/pg4.png" width="100%" alt="">
                                </div>
                                <div class="bg_banner_content">
                                    <div class="d-flex justify-content-center icon_list_content">
                                        <img src="../../../assets/img/new-kidzee/play_group_icon.png" class="icon_list"
                                            alt="">
                                    </div>
                                    <div class="card_title">Teacher Training Programme</div>
                                    <p>Zee Learn Preschool Teacher Training Programme is a Zee Learn Ltd initiative. 
                                    </p>
                                    <p class="read_more" routerLink="teacher-training-programme">Read More</p>
                                    <div class="bottom_btn_list">
                                        <div class="bottom_btn">
                                            <div class="admission_text">Admission Age Group</div>
                                            <div class="years_text">1.5 - 2.5 Years</div>
                                        </div>
                                        <div class="bottom_btn">
                                            <div class="admission_text">Duration</div>
                                            <div class="years_text">3 Hours/Day</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>


                </div>


            </div>
        </div>

    </div>
</div>